import * as React from "react";
import {cs} from "@common/react/chain-services";
import {cx} from "emotion";
import {StaticTooltipService} from "../../../../../../../../../common/tooltip3/static-tooltip-service";
import "./info-provider.scss";

export const InfoProvider = ({info, tooltipBoxWidth}) =>
    cs(
        [
            "staticTooltip",
            (_, next) =>
                StaticTooltipService({
                    direction: "top",
                    tooltipBoxWidth,
                    leftOffset: 2,
                    info,
                    next,
                }),
        ],
        ({staticTooltip}) => {
            return staticTooltip.renderIcon({
                className: cx("info-provider info-provider-5f3"),
                icon: <i className="material-icons">info</i>,
            });
        }
    );
